import BenefitsGallery from './benefits-gallery';

export default BenefitsGallery;
